import CustomerListView from '@/views/Customers/CustomerListView/CustomerListView.vue'
import CustomerDetailView from '@/views/Customers/CustomerDetailView/CustomerDetailView.vue'
import CustomerUploadView from '@/views/Customers/CustomerUploadView/CustomerUploadView.vue'
import CustomerCreateView from '@/views/Customers/CustomerCreateView/CustomerCreateView.vue'
import CustomerImportView from '@/views/Customers/CustomerImportView/CustomerImportView.vue'

export default [
  {
    path: '/merchants/:merchantID/customers',
    component: CustomerListView,
    name: 'CustomerList'
  },
  {
    path: '/merchants/:merchantID/customers/:customerID',
    component: CustomerDetailView,
    name: 'CustomerDetail'
  },
  {
    path: '/merchants/:merchantID/customers/upload',
    component: CustomerUploadView,
    name: 'CustomerUpload'
  },
  {
    path: '/merchants/:merchantID/customers/create',
    component: CustomerCreateView,
    name: 'CustomerCreate'
  },
  {
    path: '/merchants/:merchantID/customers/import',
    component: CustomerImportView,
    name: 'CustomerImport'
  }
]
